import React, { memo } from "react";
import { DropdownMatchingCellWrapper } from "./style";

const KTDropdownMatchingCell = memo(({ title }) => {
  return <DropdownMatchingCellWrapper>{title}</DropdownMatchingCellWrapper>;
});

export default KTDropdownMatchingCell;
